import { useCallback, useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { ChatThread, ThreadList } from "@/components/Chat";
import { PushToggle } from "@/components/PushToggle";

export default function TechMessages() {
  const [threads, setThreads] = useState([]);
  const [sel, setSel] = useState(null);
  const load = useCallback(() => api.get("/chat/threads").then((r) => setThreads(r.data)), []);
  useEffect(() => { load(); }, [load, sel]);

  if (sel)
    return (
      <div className="space-y-3">
        <button onClick={() => setSel(null)} className="inline-flex items-center gap-1 text-sm text-slate-500" data-testid="tech-chat-back"><ArrowLeft className="h-4 w-4" /> Conversazioni</button>
        <p className="font-display text-lg font-semibold" data-testid="chat-thread-title">{sel.job_label ? `Intervento · ${sel.job_label}` : "Ufficio"}</p>
        <ChatThread technicianId={sel.technician_id} jobId={sel.job_id} className="h-[calc(100vh-260px)]" />
      </div>
    );
  return (
    <div className="space-y-5">
      <div className="rise">
        <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#61a229]">Comunicazioni</p>
        <h1 className="mt-1 font-display text-3xl font-bold">Messaggi</h1>
      </div>
      <div className="rounded-2xl border bg-white p-4"><PushToggle /></div>
      <div className="overflow-hidden rounded-2xl border bg-white"><ThreadList threads={threads} onSelect={setSel} /></div>
    </div>
  );
}
